import { ResursTreeApi } from '../../../services/modules/tree';
import { TResursTreeNode } from '../treeTypes';

export const handleRunTask = (treeName: string, node: TResursTreeNode) => {
  ResursTreeApi.execObjectCommand({
    tree: treeName,
    objectId: [node.id],
    command: 'execNow',
  });
};
